var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_183_8304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5L5.54167 5.54167M10.5 10.5L8.45833 8.45833M10.5 3.5L8.45833 5.54167M3.5 10.5L5.54167 8.45833",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54297 5.54297H8.45964V8.45964H5.54297V5.54297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 5.54232C10.9045 5.54232 11.2992 5.42258 11.6349 5.19824C11.9707 4.97389 12.2324 4.65503 12.3869 4.28196C12.5414 3.9089 12.5819 3.49839 12.5031 3.10234C12.4243 2.7063 12.2299 2.34251 11.9443 2.05698C11.6588 1.77144 11.295 1.57699 10.899 1.49822C10.5029 1.41944 10.0924 1.45987 9.71934 1.6144C9.34628 1.76893 9.02741 2.03061 8.80307 2.36636C8.57873 2.70211 8.45899 3.09685 8.45899 3.50065M10.5007 8.45899C10.9045 8.45899 11.2992 8.57873 11.6349 8.80307C11.9707 9.02741 12.2324 9.34628 12.3869 9.71934C12.5414 10.0924 12.5819 10.5029 12.5031 10.899C12.4243 11.295 12.2299 11.6588 11.9443 11.9443C11.6588 12.2299 11.295 12.4243 10.899 12.5031C10.5029 12.5819 10.0924 12.5414 9.71934 12.3869C9.34628 12.2324 9.02741 11.9707 8.80307 11.6349C8.57873 11.2992 8.45899 10.9045 8.45899 10.5007M3.50065 8.45899C3.09685 8.45899 2.70211 8.57873 2.36636 8.80307C2.03061 9.02741 1.76893 9.34628 1.6144 9.71934C1.45987 10.0924 1.41944 10.5029 1.49822 10.899C1.57699 11.295 1.77144 11.6588 2.05698 11.9443C2.34251 12.2299 2.7063 12.4243 3.10234 12.5031C3.49839 12.5819 3.9089 12.5414 4.28196 12.3869C4.65503 12.2324 4.97389 11.9707 5.19824 11.6349C5.42258 11.2992 5.54232 10.9045 5.54232 10.5007M3.50065 5.54232C3.09685 5.54232 2.70211 5.42258 2.36636 5.19824C2.03061 4.97389 1.76893 4.65503 1.6144 4.28196C1.45987 3.9089 1.41944 3.49839 1.49822 3.10234C1.57699 2.7063 1.77144 2.34251 2.05698 2.05698C2.34251 1.77144 2.7063 1.57699 3.10234 1.49822C3.49839 1.41944 3.9089 1.45987 4.28196 1.6144C4.65503 1.76893 4.97389 2.03061 5.19824 2.36636C5.42258 2.70211 5.54232 3.09685 5.54232 3.50065",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_183_8304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "#F28181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/Drone.f573e612d6c105f48acc87df6f54f7ba.svg";
export { ForwardRef as ReactComponent };